import {
  createVesselCargoAnalysisAPI,
  getVesselCargoAnalysisListAPI,
  getVesselCargoAnalysisByIdAPI,
  deleteVesselCargoAnalysisAPI,
} from "./api";

export function createVesselCargoAnalysis(data) {
  return createVesselCargoAnalysisAPI(data)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}

export function getVesselCargoAnalysisList(query) {
  return getVesselCargoAnalysisListAPI(query)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}

export function getVesselCargoAnalysisById(id) {
  return getVesselCargoAnalysisByIdAPI(id)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}

export function deleteVesselCargoAnalysis(id) {
  return deleteVesselCargoAnalysisAPI(id)
    .then((res) => res)
    .catch((err) => Promise.reject(err));
}
